class ScreenInfo {
  constructor() {
    this._canvas = null;
  }

  get width() {
    return this._canvas ? this._canvas.clientWidth : window.innerWidth;
  }

  get height() {
    return this._canvas ? this._canvas.clientHeight : window.innerHeight;
  }

  get aspect_ratio() {
    return this.width / this.height;
  }

  _init(canvas) {
    this._canvas = canvas;
  }
}

const Screen = new ScreenInfo();

export { Screen };
